import autobind from 'autobind-decorator';
import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import { PaymentManager } from '@shared/ui-components';

import { State } from 'common/interfaces/state';
import { PaymentMethodActions } from '../../actions/creators';
import { BillingCardModel } from '../../interfaces/billing-card-model';
import { CreateBillingCardForm } from '../../interfaces/create-billing-card-form';

interface StateProps {
  paymentMethods: BillingCardModel[];
  primaryCardId: string;
  backupCardId: string;
}

interface DispatchProps {
  setPrimaryCard: (id: string) => void;
  setBackupCard: (id: string) => void;
  removeCard: (id: string) => void;
  createCard: (form: CreateBillingCardForm) => void;
}

interface Props extends StateProps, DispatchProps {
  subscriptionCardId: string;
  setSubscriptionCard: (id: string) => void;
}

class PaymentMethodSelectorComponent extends React.Component<Props> {
  public render(): JSX.Element {
    const paymentMethods = this.props.paymentMethods;
    const cards = paymentMethods && paymentMethods.map(x => ({ ...x, type: x.brand.toLowerCase() }));

    return (
      <PaymentManager
        cards={cards}
        primaryCardId={this.props.primaryCardId}
        backupCardId={this.props.backupCardId}
        subscriptionCardId={this.props.subscriptionCardId}
        setPrimaryCard={this.props.setPrimaryCard}
        setBackupCard={this.props.setBackupCard}
        setSubscriptionCard={this.props.setSubscriptionCard}
        removeCard={this.props.removeCard}
        createCard={this.createCard}
      />
    );
  }

  @autobind
  private createCard(card: { cardNumber: string, expiryDate: string, cvc: string }): void {
    const matches = card.expiryDate.match(/(\d+) \/ (\d+)/);

    this.props.createCard({
      cardNumber: card.cardNumber,
      cvv: card.cvc,
      expiryMonth: Number(matches[1]),
      expiryYear: Number(matches[2].padStart(4, '2000')),
      firstName: null,
      lastName: null,
    });
  }
}

function mapStateToProps(state: State): StateProps {
  const payment = state.account.payment;

  return {
    paymentMethods: payment && payment.cards,
    primaryCardId: payment && payment.primaryCardId,
    backupCardId: payment && payment.backupCardId,
  };
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>): DispatchProps {
  return {
    setPrimaryCard: id => dispatch(PaymentMethodActions.setPrimaryCard(id)),
    setBackupCard: id => dispatch(PaymentMethodActions.setBackupCard(id)),
    removeCard: id => dispatch(PaymentMethodActions.removeCard(id)),
    createCard: form => dispatch(PaymentMethodActions.createCard(form)),
  };
}

export const PaymentMethodSelector = connect(mapStateToProps, mapDispatchToProps)(PaymentMethodSelectorComponent);
